import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import emailFieldInfo from '@/app/editor/sidebar/elementsInfo/emailField';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'name',
    targetSelector: '.gf_textfield',
    property: 'name',
  },
  {
    type: 'html:attr',
    name: 'tf-placeholder',
    targetSelector: '.gf_textfield',
    property: 'placeholder',
  },
  {
    type: 'html:attr',
    name: 'required',
    targetSelector: '.gf_textfield',
    property: 'required',
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_textfield',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_textfield',
    property: 'height',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.gf_textfield',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.gf_textfield',
    property: 'font-family',
  },
  {
    type: 'css',
    name: 'text-color',
    targetSelector: '.gf_textfield',
    fieldType: 'color',
    property: 'color',
    require: true,
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },

  {
    type: 'html:attr',
    name: 'defaultvalue',
    targetSelector: '.gf_textfield',
    default_value: '',
    property: 'value',
  },
  {
    type: 'custom:condition',
    name: 'hideOnClient',
    targetSelector: '.gf_textfield',
    condition: {
      // eslint-disable-next-line quotes
      syntax: `"#{dataConditon}" == ""`,
      success: 1,
      fail: 0,
    },
    property: 'hide',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpEmailField extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : emailFieldInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || emailFieldInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || emailFieldInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + emailFieldInfo.class;
  }
}
